import React, { useContext, useRef } from "react";
import { MenuContext } from "../../context";

const Accordion = ({ additionalClass, className = "", id = "", title, children, target, onClick, headingTagName = "h3" }) => {
  const accordionContainer = useRef(null);
  const accordionBody = useRef(null);
  const menuContext = useContext(MenuContext);

  const handleClick = (event) => {
    if (onClick) {
      onClick(title, event);
    }
  };

  const DynamicTag = ({ tagName: Tag, children, ...props }) => {
    return <Tag {...props}>{children}</Tag>;
  };

  return (
    <details id={id} className={`accordion ${className}`.trim()} inert={menuContext.isMenuOpen ? "true" : null}>
      <summary className="accordion__head" onClick={handleClick}>
        <DynamicTag tagName={headingTagName}>
          {title}
          {target && <span id={target} style={{ visibility: "hidden" }}></span>}
        </DynamicTag>
      </summary>
      <div className="accordion__container" ref={accordionContainer}>
        <div className={`${(additionalClass && additionalClass) || ""} accordion__body`} ref={accordionBody}>
          {children}
        </div>
      </div>
    </details>
  );
};

export default Accordion;
